// TODO revise. maybe move. maybe rename. TabRef??
export enum GridTab {
    SCORECARD_GRID = 'tab_grid',
    DIRECT_REPORT_VIEW = 'tab_directrpt',
}
